module.exports = __webpack_public_path__ + "static/media/NunitoSans-LightItalic.42bffd27.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NunitoSans-LightItalic.ttf
// module id = 3412
// module chunks = 70